import { useState } from 'react';
import { Stack } from "@fluentui/react";
import { Button, Text } from '@fluentui/react-components';
import { ArrowUpload20Regular } from "@fluentui/react-icons";
import { primaryIcon } from '../../styles/customStyles';

const FileUploadComponent = (props: any) => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [fileName, setFileName] = useState('');

  const handleFileChange = (event: any) => {
    const file = event?.target?.files[0];
    setFileName(file?.name);
    if (file) {
      const reader = new FileReader();
      reader.onload = function (e: any) {
        const csvContent = e?.target?.result;
        const rows = csvContent?.split('\n');
        // const data = rows.map((row: any) => row.split(','));
        props?.setDeviceList(rows);
      };
      reader.readAsText(file);
    };
    setSelectedFile(file);
  };

  const handleUpload = () => { document.getElementById('fileUpload')?.click() };

  return (
    <>
      <Stack>
        <input style={{ "display": "none" }} type="file" accept='.csv' id="fileUpload" onChange={handleFileChange} />
        {fileName?.length > 0 && <Text> File selected: {fileName} </Text>}
      </Stack>
      <Button shape="circular" appearance="subtle" size='small' icon={<ArrowUpload20Regular {...primaryIcon} />} onClick={handleUpload}>
        Select a file
      </Button>
    </>
  );
};

export default FileUploadComponent;
